const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/newsletter/posts/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { NEWSLETTER_POST_SEARCH_MAX_LENGTH } from "@circle-react/components/SettingsApp/Newsletters/Posts/constants";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const newsletterPostsSearchSchema = z.object({
  status: z.enum(["scheduled", "draft", "published"]).optional().catch(undefined),
  query: z.union([z.string(), z.number()]).transform(value => String(value).trim().slice(0, NEWSLETTER_POST_SEARCH_MAX_LENGTH) || undefined).optional().catch(undefined)
});
export const Route = createFileRoute("/_protected/_settingsLayout/settings/newsletter/posts/")({
  validateSearch: newsletterPostsSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});